module.exports = __webpack_public_path__ + "static/media/avatar-m.5d269184.gif";